export const BASE_URL = process.env.REACT_APP_APP_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;
export const WABOTTY_API = process.env.REACT_APP_WABOTTY_API;
export const MARKETPLACE_API_URL = process.env.REACT_APP_MARKETPLACE_URL;

export const IMAGES_BASE_URL = "mercadoagentes.s3.amazonaws.com/";
export const IMAGES_URL = "mercadoagentes.s3.amazonaws.com/";
export const THUMBOR_URL = process.env.REACT_APP_THUMBOR_URL;

export const LOGIN_URL = API_URL + "auth/";
export const REFRESH_TOKEN_URL = API_URL + "refresh_token/";
export const DELIVERY = API_URL + "delivery/";
export const AUTH = API_URL + "auth/";
export const CONTACT_URL = API_URL + "contact/";
export const PAYMENTS_URL = API_URL + "payments/";
export const CUSTOMER_PAYMENTS_URL = API_URL + "customer-payments/";
export const PAYMENT_METHODS_URL = API_URL + "payment_methods/";
export const PAYMENT_GATEWAY_ACCOUNTS_URL =
  API_URL + "payment_gateway_accounts/";

export const PLACES_API = "https://geocode.search.hereapi.com/geocode?";
export const GEOCODER_API = "https://geocoder.ls.hereapi.com/6.2/geocode.json?";
export const ACCOUNT_URL = API_URL + "account/";
export const VALIDATE_SUBACCOUNT_DATA_URL = ACCOUNT_URL + "validate-subaccount-data/";
export const CREATE_COMPLETE_SUBACCOUNT_URL = ACCOUNT_URL + "create-complete-subaccount/";
export const DELETE_SUBACCOUNT_URL = (id) => ACCOUNT_URL + `${id}/delete-subaccount/`;

export const SUPPORT_URL = API_URL + "support/";
export const WABOTTY_URL = API_URL + "wabotty/";
export const WABOTTY_PUBLIC_URL = API_URL + "wabotty/public/";
export const CHATS_URL = API_URL + "chats/";

export const SECURITY_URL = API_URL + "security/";
export const CAMPAIGNS_URL = API_URL + "campaigns/";
export const CAMPAIGN_LISTS_URL = API_URL + "campaign_lists/";
export const AI_URL = API_URL + "ai/";
export const AI_GENERATE_RESPONSE_URL = AI_URL + "generate_response/";
export const QRCODE_URL = API_URL + "qrcode/";
export const CALENDAR_URL = API_URL + "calendar/";
export const CALENDAR_EVENTS_URL = API_URL + "calendar_events/";
export const CALENDAR_WORKING_HOURS_URL = API_URL + "calendar-working-hours/";
export const TEMPLATES_URL = API_URL + "templates/";
export const AUTOMATIONS_URL = API_URL + "automations/";
export const AUTOMATIONS_RULES_URL = API_URL + "automations-rule/";
export const CONTACTS_URL = API_URL + "contacts/";
export const COLUMNS_URL = API_URL + "columns/";
export const CONTACT_GROUPS_URL = API_URL + "contact-groups/";
export const NOTIFICATIONS_URL = API_URL + "notifications/";
export const BUSINESS_HOURS_URL = API_URL + "business-hours/";
export const BUSINESS_EXCEPTIONS_URL = API_URL + "business-exceptions/";
export const BUSINESS_HOURS_SETTINGS_URL = API_URL + "business-hours-settings/";
export const APPOINTMENT_TYPES_URL = API_URL + "appointment-types/";
export const RECEIVED_MESSAGES_URL = API_URL + "received-messages/";
export const SENT_MESSAGES_URL = API_URL + "sent-messages/";
export const AGENT_TESTS_URL = API_URL + "ai/openai/function_calling/";
export const GOOGLE_API_URL = API_URL + "google-api/";
export const METRICS_URL = API_URL + "metrics/";
export const CLIENTS_URL = API_URL + "clients/";

export const USERS_URL = API_URL + "users/";
export const VALIDATE_CPF_URL = API_URL + "users/validate_cpf/";

// User Departments URLs
export const USER_DEPARTMENTS_URL = API_URL + "user-departments/";
export const USER_DEPARTMENTS_DETAIL_URL = (id) => USER_DEPARTMENTS_URL + `${id}/`;
export const USER_DEPARTMENTS_USERS_URL = (id) => USER_DEPARTMENTS_URL + `${id}/users/`;

// URLs específicas dos endpoints (opcionais - já incluídas nos services)
export const CREATE_USER_SECURE_URL = USERS_URL + "create_user_secure/";
export const GET_SUPERUSERS_URL = USERS_URL + "get_superusers/";
export const UPDATE_USER_PERMISSION_URL = (id) =>
  USERS_URL + `${id}/update_user_permission/`;
export const RESET_USER_PERMISSIONS_URL = (id) =>
  USERS_URL + `${id}/reset_user_permissions/`;

export const AI_AGENTS_URL = API_URL + "agents/";
export const AI_AGENTS_IMAGES_URL = API_URL + "images/";
export const AI_AGENTS_DRAFTS_URL = API_URL + "agents-drafts/";

export const SCHEDULED_FOLLOWUPS_URL = API_URL + "scheduled-followups/";

// AI Agents Actions URLs
export const AI_AGENTS_GENERATE_PROMPT_URL = (id) =>
  API_URL + `agents/${id}/generate_prompt/`;
export const AI_AGENTS_COPY_PROMPT_URL = (id) =>
  API_URL + `agents/${id}/copy_prompt/`;
export const AI_AGENTS_EXPORT_URL = (id) => API_URL + `agents/${id}/export/`;
export const AI_AGENTS_ACTIVATE_URL = (id) =>
  API_URL + `agents/${id}/activate/`;
export const AI_AGENTS_VERSIONS_URL = (id) =>
  API_URL + `agents/${id}/versions/`;
export const AI_AGENTS_RESTORE_VERSION_URL = (id) =>
  API_URL + `agents/${id}/restore_version/`;

// AI Agents Public Links URLs
export const AI_AGENTS_PUBLIC_LINKS_URL = (id) =>
  API_URL + `agents/${id}/public-links/`;
export const AI_AGENTS_PUBLIC_LINK_DETAIL_URL = (agentId, linkId) =>
  API_URL + `agents/${agentId}/public-links/${linkId}/`;
export const AI_AGENTS_PUBLIC_LINK_TOGGLE_URL = (agentId, linkId) =>
  API_URL + `agents/${agentId}/public-links/${linkId}/toggle-status/`;
export const AI_AGENTS_PUBLIC_LINK_REGENERATE_URL = (agentId, linkId) =>
  API_URL + `agents/${agentId}/public-links/${linkId}/regenerate-token/`;
export const AI_AGENTS_PUBLIC_LINK_DUPLICATE_URL = (agentId, linkId) =>
  API_URL + `agents/${agentId}/public-links/${linkId}/duplicate/`;
export const AI_AGENTS_PUBLIC_LINK_STATS_URL = (agentId, linkId) =>
  API_URL + `agents/${agentId}/public-links/${linkId}/stats/`;
export const AI_AGENTS_PUBLIC_LINK_LOGS_URL = (agentId, linkId) =>
  API_URL + `agents/${agentId}/public-links/${linkId}/logs/`;

export const AI_AGENTS_VERSION_DETAIL_URL = (id, version) =>
  API_URL + `agents/${id}/version_detail/?version=${version}`;
export const AI_AGENTS_CREATE_VERSION_URL = (id) =>
  API_URL + `agents/${id}/create_version/`;
export const AI_AGENTS_EXPORT_VERSION_URL = (id, version = null) => {
  const baseUrl = API_URL + `agents/${id}/export_version/`;
  return version ? `${baseUrl}?version=${version}` : baseUrl;
};

// AI Agents Testing URL (usar a existente AGENT_TESTS_URL)
export const AI_AGENTS_TEST_URL = AGENT_TESTS_URL;

// AI Agents Prompt Cache URL
export const AI_AGENTS_PROMPT_CACHE_URL = AI_URL + "get_agent_prompt_cache/";

// AI Agents Images Actions URLs
export const AI_AGENTS_IMAGES_BULK_UPLOAD_URL = API_URL + "images/bulk_upload/";

// AI Agents Drafts Actions URLs
export const AI_AGENTS_DRAFTS_CURRENT_URL = API_URL + "agents-drafts/current/";
export const AI_AGENTS_DRAFTS_SAVE_URL = API_URL + "agents-drafts/save_draft/";
export const AI_AGENTS_DRAFTS_CLEAR_URL = (id) =>
  API_URL + `agents-drafts/${id}/clear/`;
export const AI_AGENTS_DRAFTS_CLEAR_EXPIRED_URL =
  API_URL + "agents-drafts/clear_expired/";

// AI Agents Training Files URLs (RAG)
export const AI_AGENTS_TRAINING_FILES_URL = API_URL + "training-files/";
export const AI_AGENTS_TRAINING_FILES_BULK_UPLOAD_URL = API_URL + "training-files/bulk_upload/";

// RAG/Knowledge Base URLs
export const RAG_PROCESS_AGENT_KNOWLEDGE_URL = API_URL + "rag/process-agent-knowledge/";
export const RAG_PROCESS_SINGLE_FILE_URL = API_URL + "rag/process-single-file/";
export const RAG_CLEAR_AGENT_URL = (agentId) => API_URL + `rag/clear-agent/${agentId}/`;

export const AGENT_DEPLOYMENTS_URL = API_URL + "agent-deployments/";

// Agent Deployments Actions URLs
export const AGENT_DEPLOYMENTS_LIST_URL = AGENT_DEPLOYMENTS_URL;
export const AGENT_DEPLOYMENTS_DETAIL_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/`;
export const AGENT_DEPLOYMENTS_ACTIVATE_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/activate/`;
export const AGENT_DEPLOYMENTS_SUSPEND_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/suspend/`;
export const AGENT_DEPLOYMENTS_CANCEL_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/cancel/`;
export const AGENT_DEPLOYMENTS_MARK_SETUP_PAID_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/mark_setup_fee_paid/`;
export const AGENT_DEPLOYMENTS_PROCESS_BILLING_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/process_billing/`;
export const AGENT_DEPLOYMENTS_BILLING_SUMMARY_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/billing_summary/`;
export const AGENT_DEPLOYMENTS_EXTEND_SUPPORT_URL = (id) => AGENT_DEPLOYMENTS_URL + `${id}/extend_support/`;
export const AGENT_DEPLOYMENTS_AVAILABLE_AGENTS_URL = AGENT_DEPLOYMENTS_URL + "available_agents/";
export const AGENT_DEPLOYMENTS_AVAILABLE_AGENT_FLOWS_URL = AGENT_DEPLOYMENTS_URL + "available_agent_flows/";
export const AGENT_DEPLOYMENTS_CREATE_URL = AGENT_DEPLOYMENTS_URL;
export const AGENT_DEPLOYMENTS_CREATE_FLOW_URL = AGENT_DEPLOYMENTS_URL + "flow_deployment/";

export const CUSTOMERS_URL = API_URL + "customers/";
export const CUSTOMER_TAGS_URL = API_URL + "customer-tags/";
export const CUSTOMER_TAG_ASSIGNMENTS_URL =
  API_URL + "customer-tag-assignments/";

//global tags
export const TAGS_URL = API_URL + "tags/";

// Customer Actions URLs
export const CUSTOMERS_BULK_UPDATE_URL = CUSTOMERS_URL + "bulk_update/";
export const CUSTOMERS_STATS_URL = CUSTOMERS_URL + "stats/";
export const CUSTOMERS_EXPORT_URL = CUSTOMERS_URL + "export/";
export const CUSTOMER_ADD_TAGS_URL = (id) => CUSTOMERS_URL + `${id}/add_tags/`;
export const CUSTOMER_REMOVE_TAGS_URL = (id) =>
  CUSTOMERS_URL + `${id}/remove_tags/`;

// Customer Tags Actions URLs
export const CUSTOMER_TAGS_USAGE_STATS_URL = CUSTOMER_TAGS_URL + "usage_stats/";

// =============================================== //
// ORGANIZATIONS URLS - UPDATED AND EXPANDED      
// =============================================== //

export const ORGANIZATIONS_URL = API_URL + "organizations/";
export const SUBACCOUNTS_URL = API_URL + "subaccounts/";
export const INVITATIONS_URL = API_URL + "invitations/";

// Organizations CRUD URLs
export const ORGANIZATIONS_LIST_URL = ORGANIZATIONS_URL;
export const ORGANIZATIONS_CREATE_URL = ORGANIZATIONS_URL;
export const ORGANIZATIONS_DETAIL_URL = (id) => ORGANIZATIONS_URL + `${id}/`;
export const ORGANIZATIONS_UPDATE_URL = (id) => ORGANIZATIONS_URL + `${id}/`;
export const ORGANIZATIONS_DELETE_URL = (id) => ORGANIZATIONS_URL + `${id}/`;

// Organizations Actions URLs
export const ORGANIZATIONS_ANALYTICS_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/analytics/`;
export const ORGANIZATIONS_ASSIGN_FEATURES_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/assign_features/`;
export const ORGANIZATIONS_UPDATE_BRANDING_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/update_branding/`;
export const ORGANIZATIONS_BRANDING_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/branding/`;
export const ORGANIZATIONS_PREVIEW_BRANDING_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/preview_branding/`;
export const ORGANIZATIONS_SUBACCOUNTS_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/subaccounts/`;

// SMTP White Label URLs
export const ORGANIZATIONS_SMTP_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/smtp/`;
export const ORGANIZATIONS_TEST_SMTP_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/test_smtp/`;

// Organizations Validation URLs
export const ORGANIZATIONS_CHECK_SLUG_URL = ORGANIZATIONS_URL + "check_slug/";
export const ORGANIZATIONS_CHECK_DOMAIN_URL =
  ORGANIZATIONS_URL + "check_domain/";
export const ORGANIZATIONS_VALIDATE_URL = ORGANIZATIONS_URL + "validate/";

// Templates de Branding URLs
export const ORGANIZATIONS_BRANDING_TEMPLATES_URL =
  ORGANIZATIONS_URL + "branding_templates/";

export const ORGANIZATIONS_APPLY_TEMPLATE_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/apply_branding_template/`;

// Validação de Branding URLs
export const ORGANIZATIONS_VALIDATE_BRANDING_URL =
  ORGANIZATIONS_URL + "validate_branding/";

export const ORGANIZATIONS_GENERATE_CSS_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/generate_css/`;

// Upload de Assets URLs
export const ORGANIZATIONS_UPLOAD_LOGO_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/upload_logo/`;

export const ORGANIZATIONS_UPLOAD_FAVICON_URL = (id) =>
  ORGANIZATIONS_URL + `${id}/upload_favicon/`;

export const ORGANIZATIONS_DELETE_ASSET_URL = (id, assetType) =>
  ORGANIZATIONS_URL + `${id}/delete_asset/${assetType}/`;

// Subaccounts Management URLs
export const SUBACCOUNTS_LIST_URL = SUBACCOUNTS_URL;
export const SUBACCOUNTS_DETAIL_URL = (id) => SUBACCOUNTS_URL + `${id}/`;
export const SUBACCOUNTS_SUMMARY_URL = SUBACCOUNTS_URL + "summary/";
export const SUBACCOUNTS_TOGGLE_STATUS_URL = (id) =>
  SUBACCOUNTS_URL + `${id}/toggle_status/`;
export const SUBACCOUNTS_UPDATE_USER_LIMIT_URL = (id) =>
  SUBACCOUNTS_URL + `${id}/update_user_limit/`;

export const SUBACCOUNTS_UPDATE_URL = (id) => SUBACCOUNTS_URL + `${id}/`;
export const SUBACCOUNTS_DELETE_URL = (id) => SUBACCOUNTS_URL + `${id}/`;

// Features URLs
export const FEATURES_URL = API_URL + "features/";
export const ACCOUNT_FEATURES_URL = ACCOUNT_URL + "features/";

// Subaccount Features URLs
export const SUBACCOUNT_FEATURES_URL = (subaccountId) =>
  API_URL + `account/${subaccountId}/features/`;
export const SUBACCOUNT_UPDATE_FEATURES_URL = (subaccountId) =>
  API_URL + `account/${subaccountId}/update-features/`;

// Account Plan URLs
export const ACCOUNT_PLAN_CURRENT_URL = ACCOUNT_URL + "plan/current/";
export const ACCOUNT_PLAN_SUBSCRIBE_URL = ACCOUNT_URL + "plan/subscribe/";
export const ACCOUNT_PLAN_UPGRADE_URL = ACCOUNT_URL + "plan/upgrade/";
export const ACCOUNT_PLAN_UPGRADE_PREVIEW_URL = ACCOUNT_URL + "plan/upgrade/preview/";
export const ACCOUNT_PLAN_CANCEL_PREVIEW_URL = ACCOUNT_URL + "plan/cancel/preview/";
export const ACCOUNT_PLAN_CANCEL_URL = ACCOUNT_URL + "plan/cancel/";
export const ACCOUNT_FEATURES_TOGGLE_URL = (featureId) =>
  ACCOUNT_URL + `features/${featureId}/toggle/`;
export const ACCOUNT_FEATURES_INCREMENT_USAGE_URL = (featureId) =>
  ACCOUNT_URL + `features/${featureId}/increment_usage/`;
export const ACCOUNT_FEATURES_RESET_USAGE_URL = (featureId) =>
  ACCOUNT_URL + `features/${featureId}/reset_usage/`;

// =============================================== //
// CUSTOMER PROFILES & BILLING PROFILES URLS     //
// =============================================== //

export const CUSTOMER_PROFILES_URL = API_URL + "customer-profiles/";
export const CUSTOMER_BILLING_PROFILES_URL = API_URL + "customer-billing-profiles/";

// Customer Profiles URLs
export const CUSTOMER_PROFILES_LIST_URL = CUSTOMER_PROFILES_URL;
export const CUSTOMER_PROFILES_CREATE_URL = CUSTOMER_PROFILES_URL;
export const CUSTOMER_PROFILES_DETAIL_URL = (id) => CUSTOMER_PROFILES_URL + `${id}/`;
export const CUSTOMER_PROFILES_UPDATE_URL = (id) => CUSTOMER_PROFILES_URL + `${id}/`;
export const CUSTOMER_PROFILES_DELETE_URL = (id) => CUSTOMER_PROFILES_URL + `${id}/`;

// Customer Billing Profiles URLs
export const CUSTOMER_BILLING_PROFILES_LIST_URL = CUSTOMER_BILLING_PROFILES_URL;
export const CUSTOMER_BILLING_PROFILES_CREATE_WITH_TOKENIZATION_URL = CUSTOMER_BILLING_PROFILES_URL + "create_with_tokenization/";
export const CUSTOMER_BILLING_PROFILES_BY_CUSTOMER_URL = CUSTOMER_BILLING_PROFILES_URL + "by_customer/";
export const CUSTOMER_BILLING_PROFILES_DETAIL_URL = (id) => CUSTOMER_BILLING_PROFILES_URL + `${id}/`;
export const CUSTOMER_BILLING_PROFILES_UPDATE_URL = (id) => CUSTOMER_BILLING_PROFILES_URL + `${id}/`;
export const CUSTOMER_BILLING_PROFILES_DELETE_URL = (id) => CUSTOMER_BILLING_PROFILES_URL + `${id}/`;
export const CUSTOMER_BILLING_PROFILES_SET_DEFAULT_URL = (id) => CUSTOMER_BILLING_PROFILES_URL + `${id}/set_default/`;

// Customer Payments URLs for Subscriptions
export const CUSTOMER_PAYMENTS_CREATE_SUBSCRIPTION_WITH_PROFILE_URL = CUSTOMER_PAYMENTS_URL + "create_subscription_with_profile/";

// =============================================== //
// TRAINING SYSTEM URLS                           //
// =============================================== //

export const TRAINING_CATEGORIES_URL = API_URL + "training-categories/";
export const TRAINING_VIDEOS_URL = API_URL + "training-videos/";
export const TRAINING_PROGRESS_URL = API_URL + "training-progress/";
export const TRAINING_REPORTS_URL = API_URL + "training-reports/";

// Training Categories URLs
export const TRAINING_CATEGORIES_LIST_URL = TRAINING_CATEGORIES_URL;
export const TRAINING_CATEGORIES_CREATE_URL = TRAINING_CATEGORIES_URL;
export const TRAINING_CATEGORIES_DETAIL_URL = (id) => TRAINING_CATEGORIES_URL + `${id}/`;
export const TRAINING_CATEGORIES_UPDATE_URL = (id) => TRAINING_CATEGORIES_URL + `${id}/`;
export const TRAINING_CATEGORIES_DELETE_URL = (id) => TRAINING_CATEGORIES_URL + `${id}/`;
export const TRAINING_CATEGORIES_VIDEOS_URL = (id) => TRAINING_CATEGORIES_URL + `${id}/videos/`;
export const TRAINING_CATEGORIES_PROGRESS_URL = (id) => TRAINING_CATEGORIES_URL + `${id}/progress/`;
export const TRAINING_CATEGORIES_USER_OVERVIEW_URL = TRAINING_CATEGORIES_URL + "user_overview/";

// Training Videos URLs
export const TRAINING_VIDEOS_LIST_URL = TRAINING_VIDEOS_URL;
export const TRAINING_VIDEOS_CREATE_URL = TRAINING_VIDEOS_URL;
export const TRAINING_VIDEOS_DETAIL_URL = (id) => TRAINING_VIDEOS_URL + `${id}/`;
export const TRAINING_VIDEOS_UPDATE_URL = (id) => TRAINING_VIDEOS_URL + `${id}/`;
export const TRAINING_VIDEOS_DELETE_URL = (id) => TRAINING_VIDEOS_URL + `${id}/`;
export const TRAINING_VIDEOS_ACCESS_CHECK_URL = (id) => TRAINING_VIDEOS_URL + `${id}/access_check/`;
export const TRAINING_VIDEOS_PLAYER_DATA_URL = (id) => TRAINING_VIDEOS_URL + `${id}/player_data/`;

// Training Progress URLs
export const TRAINING_PROGRESS_LIST_URL = TRAINING_PROGRESS_URL;
export const TRAINING_PROGRESS_START_VIDEO_URL = TRAINING_PROGRESS_URL + "start_video/";
export const TRAINING_PROGRESS_UPDATE_PROGRESS_URL = TRAINING_PROGRESS_URL + "update_progress/";
export const TRAINING_PROGRESS_COMPLETE_VIDEO_URL = TRAINING_PROGRESS_URL + "complete_video/";
export const TRAINING_PROGRESS_MY_SUMMARY_URL = TRAINING_PROGRESS_URL + "my_summary/";
export const TRAINING_PROGRESS_DASHBOARD_URL = TRAINING_PROGRESS_URL + "dashboard/";

// Training Reports URLs (Admin only)
export const TRAINING_REPORTS_USERS_PROGRESS_URL = TRAINING_REPORTS_URL + "users_progress/";
export const TRAINING_REPORTS_VIDEOS_ANALYTICS_URL = TRAINING_REPORTS_URL + "videos_analytics/";
export const TRAINING_REPORTS_CATEGORY_OVERVIEW_URL = TRAINING_REPORTS_URL + "category_overview/";

// =============================================== //
// SUPPORT SYSTEM URLS                           //
// =============================================== //

// Support Configuration URLs
export const SUPPORT_CONFIG_URL = API_URL + "support-config/";
export const SUPPORT_CONFIG_LIST_URL = SUPPORT_CONFIG_URL;
export const SUPPORT_CONFIG_CREATE_URL = SUPPORT_CONFIG_URL;
export const SUPPORT_CONFIG_DETAIL_URL = (id) => SUPPORT_CONFIG_URL + `${id}/`;
export const SUPPORT_CONFIG_UPDATE_URL = (id) => SUPPORT_CONFIG_URL + `${id}/`;

// Support Tickets URLs
export const SUPPORT_TICKETS_URL = API_URL + "tickets/";
export const SUPPORT_TICKETS_LIST_URL = SUPPORT_TICKETS_URL;
export const SUPPORT_TICKETS_CREATE_URL = SUPPORT_TICKETS_URL;
export const SUPPORT_TICKETS_DETAIL_URL = (id) => SUPPORT_TICKETS_URL + `${id}/`;
export const SUPPORT_TICKETS_UPDATE_URL = (id) => SUPPORT_TICKETS_URL + `${id}/`;
export const SUPPORT_TICKETS_ASSIGN_URL = (id) => SUPPORT_TICKETS_URL + `${id}/assign/`;

// Support Chats URLs
export const SUPPORT_CHATS_URL = API_URL + "support-chats/";
export const SUPPORT_CHATS_LIST_URL = SUPPORT_CHATS_URL;
export const SUPPORT_CHATS_CREATE_URL = SUPPORT_CHATS_URL;
export const SUPPORT_CHATS_DETAIL_URL = (id) => SUPPORT_CHATS_URL + `${id}/`;
export const SUPPORT_CHATS_ASSIGN_URL = (id) => SUPPORT_CHATS_URL + `${id}/assign/`;
export const SUPPORT_CHATS_CLOSE_URL = (id) => SUPPORT_CHATS_URL + `${id}/close/`;
export const SUPPORT_CHATS_MESSAGES_URL = (id) => SUPPORT_CHATS_URL + `${id}/messages/`;

// Support Agents URLs
export const SUPPORT_AGENTS_URL = API_URL + "support-agents/";
export const SUPPORT_AGENTS_LIST_URL = SUPPORT_AGENTS_URL;
export const SUPPORT_AGENTS_CREATE_URL = SUPPORT_AGENTS_URL;
export const SUPPORT_AGENTS_DETAIL_URL = (id) => SUPPORT_AGENTS_URL + `${id}/`;
export const SUPPORT_AGENTS_UPDATE_URL = (id) => SUPPORT_AGENTS_URL + `${id}/`;
export const SUPPORT_AGENTS_UPDATE_STATUS_URL = (id) => SUPPORT_AGENTS_URL + `${id}/update_status/`;
export const SUPPORT_AGENTS_AVAILABLE_URL = SUPPORT_AGENTS_URL + "available/";

// =============================================== //
// PUBLICATIONS URLS                              //
// =============================================== //

export const PUBLICATIONS_URL = MARKETPLACE_API_URL + "publications/";

// Marketplace URLs (usando a mesma base do publications para o novo módulo)
export const MARKETPLACE_URL = MARKETPLACE_API_URL + "marketplace/";
export const MARKETPLACE_CATEGORIES_URL =
  MARKETPLACE_API_URL + "marketplace/categories/";
export const MARKETPLACE_AGENTS_URL = MARKETPLACE_API_URL + "marketplace/agents/";

//REMOVER FUTURAMENTE AS URLS ACIMA

// Marketplace Leads URLs
export const MARKETPLACE_LEADS_URL = MARKETPLACE_API_URL + "leads/";
export const MARKETPLACE_LEADS_DETAIL_URL = (id) => MARKETPLACE_LEADS_URL + `${id}/`;
export const MARKETPLACE_LEADS_EXPORT_URL = MARKETPLACE_LEADS_URL + "export/";
export const MARKETPLACE_LEADS_STATS_URL = MARKETPLACE_LEADS_URL + "stats/";

// Whitelabel URLs
export const WHITELABEL_CONFIG_URL = API_URL +  "whitelabel-config/";

// Turnstile URLs
export const TURNSTILE_CONFIG_URL = API_URL + "auth/turnstile/";

// Publications CRUD URLs
export const PUBLICATIONS_LIST_URL = PUBLICATIONS_URL;
export const PUBLICATIONS_CREATE_URL = PUBLICATIONS_URL;
export const PUBLICATIONS_DETAIL_URL = (id) => PUBLICATIONS_URL + `${id}/`;
export const PUBLICATIONS_UPDATE_URL = (id) => PUBLICATIONS_URL + `${id}/`;
export const PUBLICATIONS_DELETE_URL = (id) => PUBLICATIONS_URL + `${id}/`;

// Publications Actions URLs
export const PUBLICATIONS_STATUS_SUMMARY_URL = PUBLICATIONS_URL + "status_summary/";
export const PUBLICATIONS_PUBLISH_URL = (id) => PUBLICATIONS_URL + `${id}/publish/`;
export const PUBLICATIONS_REJECT_URL = (id) => PUBLICATIONS_URL + `${id}/reject/`;
export const PUBLICATIONS_SUSPEND_URL = (id) => PUBLICATIONS_URL + `${id}/suspend/`;
export const PUBLICATIONS_REMOVE_URL = (id) => PUBLICATIONS_URL + `${id}/remove/`;

// =============================================== //
// SELLER STORES URLS (MERCADOSHOP)              //
// =============================================== //

export const SELLER_STORES_URL = MARKETPLACE_API_URL + "seller-stores/";

// Seller Stores CRUD URLs
export const SELLER_STORES_LIST_URL = MARKETPLACE_API_URL + "seller-profiles/my_seller_data/";
export const SELLER_STORES_CREATE_URL = SELLER_STORES_URL;
export const SELLER_STORES_DETAIL_URL = (storeSlug) => SELLER_STORES_URL + `${storeSlug}/`;
export const SELLER_STORES_UPDATE_URL = (storeSlug) => SELLER_STORES_URL + `${storeSlug}/`;
export const SELLER_STORES_DELETE_URL = (storeSlug) => SELLER_STORES_URL + `${storeSlug}/`;
export const SELLER_STORES_CHECK_NAME_URL = SELLER_STORES_URL + "check_store_name/";
export const SELLER_STORES_CHECK_SLUG_AVAILABILITY_URL = SELLER_STORES_URL + "check_slug_availability/";

export const GAMIFICATION_URL = API_URL + "gamification/";
export const GOOGLE_CALENDAR_URL = API_URL + "google-calendar/";
export const INTEGRATIONS_URL = API_URL + "integrations/";

// =============================================== //
// MARKETPLACE BANNERS URLS                       //
// =============================================== //

export const MARKETPLACE_BANNERS_URL =
  MARKETPLACE_API_URL + "admin/banners/";

// Marketplace Banners CRUD URLs
export const MARKETPLACE_BANNERS_LIST_URL = MARKETPLACE_BANNERS_URL;
export const MARKETPLACE_BANNERS_CREATE_URL = MARKETPLACE_BANNERS_URL;
export const MARKETPLACE_BANNERS_DETAIL_URL = (id) => MARKETPLACE_BANNERS_URL + `${id}/`;
export const MARKETPLACE_BANNERS_UPDATE_URL = (id) => MARKETPLACE_BANNERS_URL + `${id}/`;
export const MARKETPLACE_BANNERS_DELETE_URL = (id) => MARKETPLACE_BANNERS_URL + `${id}/`;

// Marketplace Banners Actions URLs
export const MARKETPLACE_BANNERS_TOGGLE_ACTIVE_URL = (id) => MARKETPLACE_BANNERS_URL + `${id}/toggle_active/`;
export const MARKETPLACE_BANNERS_DUPLICATE_URL = (id) => MARKETPLACE_BANNERS_URL + `${id}/duplicate/`;
export const MARKETPLACE_BANNERS_BULK_UPDATE_ORDER_URL = MARKETPLACE_BANNERS_URL + "bulk_update_order/";
export const MARKETPLACE_BANNERS_STATS_URL = MARKETPLACE_BANNERS_URL + "stats/";

// Marketplace Homepage (banners integrados)
export const MARKETPLACE_HOMEPAGE_URL = API_URL + "marketplace/homepage/";

// Marketplace Banners Metrics URLs (public, without authentication)
export const MARKETPLACE_BANNERS_TRACK_VIEW_URL = (id) => API_URL + `marketplace/banners/${id}/track_view/`;
export const MARKETPLACE_BANNERS_TRACK_CLICK_URL = (id) => API_URL + `marketplace/banners/${id}/track_click/`;
export const MARKETPLACE_BANNERS_TRACK_METRICS_URL = API_URL + "marketplace/banners/track_metrics/";

// Agent Integration URLs
export const SETUP_GOOGLE_CALENDAR_INTEGRATION_URL = (agentId) => 
  API_URL + `agents/${agentId}/setup_google_calendar_integration/`;
export const REMOVE_GOOGLE_CALENDAR_INTEGRATION_URL = (agentId) => 
  API_URL + `agents/${agentId}/remove_google_calendar_integration/`;

// =============================================== //
// PUBLIC WHATSAPP API URLS (NO AUTHENTICATION) //
// =============================================== //

// Public WhatsApp Connection URLs
export const PUBLIC_WHATSAPP_TOKEN_INFO_URL = (token) => WABOTTY_PUBLIC_URL + `info/${token}/`;
export const PUBLIC_WHATSAPP_CONNECT_URL = (token) => WABOTTY_PUBLIC_URL + `connect/${token}/`;
export const PUBLIC_WHATSAPP_QR_URL = (token) => WABOTTY_PUBLIC_URL + `qr/${token}/`;
export const PUBLIC_WHATSAPP_STATUS_URL = (token) => WABOTTY_PUBLIC_URL + `status/${token}/`;

// =============================================== //
// PRODUCTS URLS                                  //
// =============================================== //

export const PRODUCTS_URL = API_URL + "products/";
export const PRODUCTS_IMAGES_URL = API_URL + "product-images/";

// Products CRUD URLs
export const PRODUCTS_LIST_URL = PRODUCTS_URL;
export const PRODUCTS_CREATE_URL = PRODUCTS_URL;
export const PRODUCTS_DETAIL_URL = (id) => PRODUCTS_URL + `${id}/`;
export const PRODUCTS_UPDATE_URL = (id) => PRODUCTS_URL + `${id}/`;
export const PRODUCTS_DELETE_URL = (id) => PRODUCTS_URL + `${id}/`;

// Products Actions URLs
export const PRODUCTS_STATS_URL = PRODUCTS_URL + "stats/";
export const PRODUCTS_BY_AGENT_URL = (agentId) => PRODUCTS_URL + `by_agent/${agentId}/`;

// Products Images URLs
export const PRODUCTS_IMAGES_LIST_URL = PRODUCTS_IMAGES_URL;
export const PRODUCTS_IMAGES_UPLOAD_URL = PRODUCTS_IMAGES_URL;
export const PRODUCTS_IMAGES_DELETE_URL = (id) => PRODUCTS_IMAGES_URL + `${id}/`;
export const PRODUCTS_IMAGES_BY_PRODUCT_URL = (productId) => PRODUCTS_IMAGES_URL + `by_product/${productId}/`;

// =============================================== //
// LEAD FOLLOW-UP (REACTIVATION) URLS             //
// =============================================== //

export const LEAD_REACTIVATION_CONFIG_URL = (agentId) => AI_URL + `reactivation/config/${agentId}/`;

// =============================================== //
// TIME-RANGE MESSAGE URLS                         //
// =============================================== //

export const TIME_RANGE_MESSAGE_CONFIG_URL = (agentId) => AI_URL + `time-range-message/config/${agentId}/`;

// =============================================== //
// CRM PIPELINE URLS                               //
// =============================================== //

export const PIPELINES_URL = API_URL + "pipelines/";
export const ACTIVITIES_URL = API_URL + "activities/";
export const SAVED_VIEWS_URL = API_URL + "saved-views/";
export const PROPERTY_DEFINITIONS_URL = API_URL + "property-definitions/";
export const PIPELINE_AUTOMATIONS_URL = API_URL + "pipeline-automations/";
export const CRM_DASHBOARD_URL = API_URL + "crm/dashboard/";

// Pipeline Actions
export const PIPELINES_REORDER_URL = PIPELINES_URL + "reorder/";
export const PIPELINES_FUNNEL_URL = (id) => PIPELINES_URL + `${id}/funnel/`;
export const PIPELINES_SUMMARY_URL = (id) => PIPELINES_URL + `${id}/summary/`;
export const PIPELINES_SHARE_URL = (id) => PIPELINES_URL + `${id}/share/`;

// Column Actions
export const COLUMNS_BOARD_URL = COLUMNS_URL + "board/";
export const COLUMNS_REORDER_URL = COLUMNS_URL + "reorder/";
export const COLUMNS_STATS_URL = (id) => COLUMNS_URL + `${id}/stats/`;
export const COLUMNS_MOVE_ALL_URL = (id) => COLUMNS_URL + `${id}/move-all/`;

// Contact CRM Actions
export const CONTACTS_SEARCH_URL = CONTACTS_URL + "search/";
export const CONTACTS_BULK_MOVE_URL = CONTACTS_URL + "bulk-move/";
export const CONTACTS_BULK_ASSIGN_URL = CONTACTS_URL + "bulk-assign/";
export const CONTACTS_BULK_TAG_URL = CONTACTS_URL + "bulk-tag/";
export const CONTACTS_BULK_DELETE_URL = CONTACTS_URL + "bulk_delete/";
export const CONTACTS_CHECK_DUPLICATES_URL = CONTACTS_URL + "check-duplicates/";
export const CONTACTS_EXPORT_URL = CONTACTS_URL + "export/";
export const CONTACTS_IMPORT_URL = CONTACTS_URL + "import/";
export const CONTACTS_CRM_SUMMARY_URL = (id) => CONTACTS_URL + `${id}/crm-summary/`;
export const CONTACTS_REORDER_URL = CONTACTS_URL + "reorder/";
export const CONTACTS_TIMELINE_URL = (id) => CONTACTS_URL + `${id}/timeline/`;
export const CONTACTS_ACTIVITIES_URL = (id) => CONTACTS_URL + `${id}/activities/`;
export const CONTACTS_TAGS_URL = (id) => CONTACTS_URL + `${id}/tags/`;
export const CONTACTS_REMOVE_TAG_URL = (id, tagId) => CONTACTS_URL + `${id}/tags/${tagId}/`;
export const CONTACTS_TRANSFER_PIPELINE_URL = (id) => CONTACTS_URL + `${id}/transfer-pipeline/`;
export const CONTACTS_CONVERT_TO_CUSTOMER_URL = (id) => CONTACTS_URL + `${id}/convert-to-customer/`;

// /reports — Insights endpoints
export const INSIGHTS_AI_PERFORMANCE_URL = METRICS_URL + "insights/ai-performance/";
export const INSIGHTS_GROWTH_URL = METRICS_URL + "insights/growth/";
export const INSIGHTS_BOTTLENECKS_URL = METRICS_URL + "insights/bottlenecks/";
export const INSIGHTS_TEAM_URL = METRICS_URL + "insights/team/";
export const CONTACTS_NOTES_URL = (id) => CONTACTS_URL + `${id}/notes/`;
export const CONTACTS_DELETE_NOTE_URL = (id, noteId) => CONTACTS_URL + `${id}/notes/${noteId}/`;
export const CONTACTS_PIN_NOTE_URL = (id, noteId) => CONTACTS_URL + `${id}/notes/${noteId}/pin/`;

// Activity Actions
export const ACTIVITIES_COMPLETE_URL = (id) => ACTIVITIES_URL + `${id}/complete/`;
export const ACTIVITIES_TODAY_URL = ACTIVITIES_URL + "today/";
export const ACTIVITIES_OVERDUE_URL = ACTIVITIES_URL + "overdue/";
export const ACTIVITIES_BULK_COMPLETE_URL = ACTIVITIES_URL + "bulk-complete/";

// Saved Views Actions
export const SAVED_VIEWS_REORDER_URL = SAVED_VIEWS_URL + "reorder/";

// Property Definitions Actions
export const PROPERTY_DEFINITIONS_REORDER_URL = PROPERTY_DEFINITIONS_URL + "reorder/";

// Pipeline Automations Actions
export const PIPELINE_AUTOMATIONS_TOGGLE_URL = (id) => PIPELINE_AUTOMATIONS_URL + `${id}/toggle/`;

// CRM Dashboard Actions
export const CRM_DASHBOARD_SUMMARY_URL = CRM_DASHBOARD_URL + "summary/";
export const CRM_DASHBOARD_FUNNEL_URL = CRM_DASHBOARD_URL + "funnel/";
export const CRM_DASHBOARD_BY_PERIOD_URL = CRM_DASHBOARD_URL + "by-period/";
export const CRM_DASHBOARD_BY_OWNER_URL = CRM_DASHBOARD_URL + "by-owner/";
export const CRM_DASHBOARD_LOSS_REASONS_URL = CRM_DASHBOARD_URL + "loss-reasons/";
export const CRM_DASHBOARD_ACTIVITIES_URL = CRM_DASHBOARD_URL + "activities/";

// =============================================== //
// ONBOARDING URLS                                //
// =============================================== //

export const ONBOARDING_URL = API_URL + "onboarding/";
export const ONBOARDING_STATUS_URL = ONBOARDING_URL + "status/";
export const ONBOARDING_COMPLETE_URL = ONBOARDING_URL + "complete/";
export const ONBOARDING_SKIP_URL = ONBOARDING_URL + "skip/";
export const ONBOARDING_ANALYTICS_URL = ONBOARDING_URL + "analytics/";
export const ONBOARDING_RESET_URL = ONBOARDING_URL + "reset/";

